<template>
  <nav id="menu" class="nav-main" role="navigation">
    <ul class="nav nav-main">
      <item
        v-for="item in list"
        :key="item.id"
        :item="item"
        @collapseSidebar="closeSidebar"
      ></item>
    </ul>
  </nav>
</template>

<script>
import item from "./item";
import { menu } from "@/assets/theme";

export default {
  components: { item },
  data() {
    return {
      list: [],
    };
  },
  mounted() {
    this.load(true);
  },
  watch: {
    $route() {
      this.update();
    },
    list: {
      handler(newVal) {
        let homePageStatus = newVal[0].isActive; //只判定 Nav 第一個 item 的值 (儀錶板)
        if (homePageStatus === true) {
          var htmlElement = document.documentElement;
          // 移除<html>上的'sidebar-left-opened'
          htmlElement.classList.remove("sidebar-left-opened");
        }
      },
      deep:true
    },
  },
  methods: {
    load(reset) {
      this.$root.functions(reset).then((a) => {
        this.list = [
          {
            text: "儀表板",
            url: "/",
            type: "page",
            icon: "fa-home",
            isActive: false,
            children: [],
          },
          ...a.body,
        ];
        this.$nextTick(menu);
        this.update();
      });
    },
    update() {
      let self = this;
      let name = this.$route.name || "/";
      let deep = 0;
      let list = [];
      let flag = true;
      let pages = [];
      let operations = [];

      (function x(a, i) {
        if (!a) return false;
        let result = false;
        a.forEach((b) => {
          if (["operation", "api"].includes(b.type)) return false;
          b.isActive = false;
          if (b.url == name || x(b.children, i + 1)) {
            result = true;
            if (deep === 0) {
              self.$root.subTitle = b.text;
              self.$root.title = b.text;
            }
            if (deep === 1) self.$root.title = b.text;
            deep++;
            b.isActive = true;
            if (flag) list.push(b);
            if (i == 0) flag = false;
            if (operations.length < 1)
              operations = b.children.filter((c) => c.type == "operation");
          }
        });
        return result;
      })(this.list, 0);
      this.$store.commit("operations", operations);
      this.$emit("update", list.reverse());
    },
    closeSidebar() {
      //接受子層item 的 emit 事件
      var htmlElement = document.documentElement;
      // 移除<html>上的'sidebar-left-opened'
      htmlElement.classList.remove("sidebar-left-opened");
      // console.log("thisList",this.list)
    },
  },
};
</script>
